import { Node, mergeAttributes, wrappingInputRule } from '@tiptap/core';
interface LangMalayOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    langMalay: {
      /**
       * Set a langMalay node
       */
      setLangMalay: () => ReturnType;
      /**
       * Toggle a langMalay node
       */
      toggleLangMalay: () => ReturnType;
      /**
       * Unset a langMalay node
       */
      unsetLangMalay: () => ReturnType;
    };
  }
}

const inputRegex = /^\s*>\s$/;

const langMalayType = 'langMalay';

const LangMalay = Node.create<LangMalayOptions>({
  name: langMalayType,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  content: 'block+',

  group: 'block',

  defining: true,

  addAttributes() {
    return {
      id: {
        default: null,
      },
      style: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [{ tag: 'lang-malay' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'lang-malay',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {}),
      0,
    ];
  },

  addCommands() {
    return {
      setLangMalay: () => ({ commands }) => {
        return commands.wrapIn(this.name);
      },
      toggleLangMalay: () => ({ commands }) => {
        return commands.toggleWrap(this.name);
      },
      unsetLangMalay: () => ({ commands }) => {
        return commands.lift(this.name);
      },
    };
  },

  addInputRules() {
    return [
      wrappingInputRule({
        find: inputRegex,
        type: this.type,
      }),
    ];
  },
});

export default { node: LangMalay, type: langMalayType };
